import createSimpleValidator from './createSimpleValidator';

const errorString = 'Vous devez entrer un numéro de téléphone fixe valide (10 chiffres).';
const checkIsHousePhoneNumber = createSimpleValidator(
    (value) => value && /^0[1234589][0-9]{8}$/.test(value.replace(/ /g, '')),
    errorString,
);

export default checkIsHousePhoneNumber;
